import React from 'react';
import { connect } from 'react-redux';
import Image from 'next/image';

import { importStatic } from 'utils';

import GoogleAdBanner from '../components/googleAdBanner';

class Footer extends React.Component {
  render() {
    const { hideFooter, hideOnlyFooter, showSalesContactInfo, hideFooterAds, isHomePage } =
      this.props;

    const ContactInfo = () => (
      <>
        <p className="footer-text">
          Email: <span className="email-text">support@zippia.com</span>
        </p>
      </>
    );

    const SalesContactInfo = () => (
      <article className="z-mb-16">
        <p className="semi-bold-font text-uppercase h6 mt-0">Contact Sales:</p>
        <p className="footer-text">
          Email:{' '}
          <a href="mailto:sales@zippia.com" className="email-text">
            sales@zippia.com
          </a>
        </p>
        <p className="footer-text mb-0">
          Phone: <span className="white-text semi-bold-text">(205) 947-2651</span>
        </p>
      </article>
    );

    return !hideFooter || !hideOnlyFooter ? (
      <footer className="footer">
        {!hideFooterAds && (
          <div className="container">
            <div className="row mb-5">
              <div className="col-12">
                <GoogleAdBanner
                  style={{
                    height: '125px',
                    maxHeight: '125px',
                    width: '100%',
                  }}
                  adSlot="3654063223"
                />
              </div>
            </div>
          </div>
        )}
        <div className="container">
          <div className="row  footer-nav ">
            <div className="col-md-3 col-12 footer-logo mb-3 mb-md-0">
              <a href="/">
                <img
                  width="153"
                  height="36"
                  src={importStatic('/ui-router/logo/medium.png')}
                  alt="Zippia"
                />
              </a>
              {!hideFooterAds && (
                <GoogleAdBanner
                  style={{
                    height: '255px',
                    maxHeight: '255px',
                    width: '100%',
                    margin: '0 auto',
                  }}
                  adSlot="3930036028"
                />
              )}
              <div className="d-flex flex-md-column flex-column-reverse">
                <span>
                  {showSalesContactInfo ? <SalesContactInfo /> : <ContactInfo />}
                  <p className="footer-text">{`Copyright © ${new Date().getFullYear()} Zippia, Inc.`}</p>
                </span>
                {isHomePage && (
                  <p className="footer-text z-mt-0 z-mb-40 z-mt-md-20">
                    <a href="https://www.facebook.com/Zippia/">
                      <img
                        src={importStatic('/ui-router/images/social-media/facebook.svg')}
                        alt="Facebook"
                        className="z-mr-20"
                      />
                    </a>
                    <a href="https://www.linkedin.com/company/zippia/">
                      <img
                        src={importStatic('/ui-router/images/social-media/linkedin.svg')}
                        alt="LinkedIn"
                        className="z-mr-20"
                      />
                    </a>
                    <a href="https://www.youtube.com/c/Zippia/videos">
                      <img
                        src={importStatic('/ui-router/images/social-media/youtube.svg')}
                        alt="YouTube"
                        className="z-mr-20"
                      />
                    </a>
                    <a href="https://twitter.com/zippiainc?lang=en">
                      <img
                        src={importStatic('/ui-router/images/social-media/twitter.svg')}
                        alt="Twitter"
                        className="z-mr-20"
                      />
                    </a>
                  </p>
                )}
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="semi-bold-font text-uppercase h6 mt-0">Zippia</div>
              <ul className="p-0 m-0">
                <li>
                  <a href="/about-us/"> About Us</a>
                </li>
                <li>
                  <a href="/employer/hiring/">Zippia Hiring Hub</a>
                </li>
                <li>
                  <a href="/terms-of-use/">Terms of Use</a>
                </li>
                <li>
                  <a href="/privacy-policy/">Privacy Policy</a>
                </li>
                <li>
                  <a href="/contact-us/">Contact Us</a>
                </li>
              </ul>
            </div>
            <div className="col-md-3 col-6">
              <div className="semi-bold-font text-uppercase h6 mt-0 footer-career-jobs">
                Careers & Jobs
              </div>
              <ul className="p-0 m-0">
                <li>
                  <a href="/resume-builder/?src=footer">Resume Builder</a>
                </li>
                <li>
                  <a href="/answers/">Job Search Q&A</a>
                </li>
                <li>
                  <a href="/jobs/full-time-jobs/">Full Time Jobs</a>
                </li>
                <li>
                  <a href="/jobs/part-time-jobs/">Part Time Jobs</a>
                </li>
                <li>
                  <a href="/jobs/work-from-home-jobs/">Work From Home Jobs</a>
                </li>
              </ul>
            </div>
            <div className="col-md-3 col-12 mt-4 mt-md-0 text-center">
              <div className="d-flex d-flex flex-sm-row flex-md-column zippiColumn">
                <Image
                  width={120}
                  height={120}
                  src={importStatic('/ui-router/images/footer/zippi-homepage.svg')}
                  alt="Zippi"
                />
                <p className="openSansH4 z-mb-30 z-mt-18 text-white">
                  Zippi <br /> Your Career Sidekick
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    ) : null;
  }
}

export default connect(
  ({ locals }) => ({
    hideFooter: !!locals.hideFooter,
    hideOnlyFooter: !!locals.hideOnlyFooter,
  }),
  null
)(Footer);
